<!--
/**
* @name: ApplyList.vue
* @description: 销售申请列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input clearable v-model="para.name" placeholder="请输入门店名称"></k-input>
      </y-query-item>
      <y-query-item>
        <k-auto-complete ref="au" :data="companyList" v-model="para.companyCode" key-field="code" value-field="name" search-field="name" layer-width="" placeholder="请选择推广公司">
          <div slot-scope="{ row }" :key="row.code" class="list">
            <span class="name">{{ row.name }}</span>
          </div>
        </k-auto-complete>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择控货渠道" clearable v-model="para.channelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input clearable v-model="para.goodsNumber" placeholder="请输入商品货号"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择审核状态" clearable v-model="para.verifyStatus">
          <k-option v-for="item in statusList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="date" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择创建时间 " style="width: 300px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <k-button type="primary" @click="verify(1)">初审</k-button>
      <k-button type="primary" @click="verify(2)">终审</k-button>
      <k-button type="primary" @click="refuseApply">拒绝申请</k-button>
    </y-query>
    <k-table
      :data="dataList"
      hasCheckbox
      checkboxKey="id"
      :selectedKeys.sync="selectedsKeys"
      :selectedRows.sync="selectedRows"
      :height="$root.tableHeightXXX"
      :rightFixedNumber="1"
      :columns="initColumns()"
    ></k-table>
    <k-pagination :total="total" v-if="dataList && dataList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    <!-- 填写拒绝申请弹窗区域 -->
    <k-popup bind="v-if" okText="保存" title="拒绝原因" :show.sync="popupShow" @after-ok="onSave">
      <div style="width: 650px;">
        <k-input tag="textarea" :class="css.textarea" v-model="reason" block placeholder="请输入拒绝原因"></k-input>
      </div>
    </k-popup>
    <!-- 填写拒绝申请弹窗区域 end-->
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_PAGELIST,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_VERIFY,
} from "@/assets/modules/apiList";
const initPara = () => ({
  name: "",
  companyCode: "",
  channelCode: "",
  goodsNumber: "",
  reason: "",
  verifyStatus: "",
  createTimeStart: "",
  createTimeEnd: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      dataList: [],
      companyList: [],
      channelList: [],
      statusList: [
        { code: "1", name: "待子公司审核审核" },
        { code: "5", name: "待总部审核" },
        { code: "10", name: "审核通过" },
        { code: "20", name: "审核拒绝" },
      ],
      para: initPara(),
      selectedsKeys: [],
      selectedsRows: [],
      total: 0,
      date: "",
      popupShow: false,
      isLoading: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "门店ID",
          field: "shopCode",
          style: {
            width: 100,
            textAlign: "center",
          },
        },
        {
          name: "门店名称",
          field: "shopName",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "销售渠道",
          field: "channelName",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "推广公司",
          field: "companyName",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "申请销售商品货号",
          field: "goodsNumber",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "申请销售商品名称",
          field: "goodsNumberName",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "审核状态",
          field: "",
          style: {
            width: 120,
            textAlign: "center",
          },
          customRender: (row) => {
            let tmp = "";
            this.statusList.forEach((d) => {
              if (row.verifyStatus == d.code) {
                tmp = d.name;
              }
            });
            return <div>{tmp}</div>;
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 130,
            textAlign: "center",
          },
        },
        {
          name: "操作",
          field: "action",
          style: { textAlign: "center" },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            return <div>{previewButton}</div>;
          },
        },
      ];
    },
    onView(row) {
      let { id } = row;
      this.$controller.open({
        name: "applyDetail",
        query: {
          refresh: new Date() - 0,
          id,
          view: 1,
        },
      });
    },
    changeDate(date) {
      this.date = date;
    },
    onSave() {
      let { tip } = this.$root;
      if (this.selectedsKeys.length === 0 || !this.selectedsKeys) {
        return tip("请输入需审核的销售申请");
      }
      if (!this.reason) {
        return tip("请输入审核拒绝原因");
      }
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_VERIFY,
        para: { verifyStatus: 20, idList: this.selectedsKeys, rejectReason: this.reason },
      }).then((res) => {
        tip("审核拒绝");
        this.selectedsKeys = [];
        this.selectedsRows = [];
        this.getApplyList();
        this.popupShow = false;
      });
    },
    verify(type) {
      let { tip } = this.$root;
      if (this.selectedsKeys.length === 0 || !this.selectedsKeys) {
        return tip("请输入需审核的销售申请");
      }
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_VERIFY,
        para: { verifyStatus: type == "1" ? 5 : 10, idList: this.selectedsKeys },
      }).then((res) => {
        tip("审核成功");
        this.selectedsKeys = [];
        this.selectedsRows = [];
        this.getApplyList();
      });
    },
    refuseApply() {
      this.popupShow = true;
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getApplyList();
    },
    onReset() {
      this.para = initPara();
      this.date = "";
      this.$refs.au.inputText = "";
      this.getApplyList();
    },
    getApplyList() {
      this.isLoading = true;
      let { para } = this;
      para.createTimeStart = this.date && this.date.length > 0 ? this.date[0] : "";
      para.createTimeEnd = this.date && this.date.length > 0 ? this.date[1] : "";
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_GOODS_APPLY_PAGELIST,
        para,
      }).then((res) => {
        this.dataList = res.pageList || [];
        this.total = res.total;
        this.isLoading = false;
      });
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getCompanyList() {
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
        para: {},
      }).then((res) => {
        this.companyList = res || [];
      });
    },
  },
  created() {
    this.getChannelList();
    this.getCompanyList();
    this.getApplyList();
  },
};
</script>

<style lang="postcss" module="css">
.textarea {
  height: 100px;
  & :global(.k-textarea) {
    height: 100px !important;
    resize: none;
  }
}
</style>
